import {
  Box,
  Card,
  CardBody,
  Heading,
  HStack,
  Icon,
  Text,
} from "@chakra-ui/react";
import type { IconType } from "react-icons";
import type { ReactNode } from "react";

interface Props {
  icon: IconType;
  title: string;
  count?: number;
  children: ReactNode;
  borderColor?: string;
  headerBg?: string;
  headerBorderColor?: string;
  iconColor?: string;
}

export const SectionCard = ({
  icon,
  title,
  count,
  children,
  borderColor = "smBorder",
  headerBg,
  headerBorderColor,
  iconColor = "smPrimary",
}: Props) => (
  <Card
    variant="outline"
    rounded="xl"
    bg="smBackground"
    borderColor={borderColor}
    boxShadow="sm"
    overflow="hidden"
  >
    <Box
      px={{ base: "4", md: "6" }}
      py="4"
      borderBottom="1px solid"
      borderColor={headerBorderColor ?? borderColor}
      bg={headerBg}
    >
      <HStack spacing="3" align="center" justify="space-between">
        <HStack spacing="3" align="center">
          <Icon as={icon} boxSize="5" color={iconColor} />
          <Heading as="h2" size="md">
            {title}
          </Heading>
        </HStack>
        {count !== undefined && (
          <Text color="smPrimary" fontWeight="semibold" fontSize="sm">
            {count}
          </Text>
        )}
      </HStack>
    </Box>
    <CardBody px={{ base: "4", md: "6" }} py={{ base: "5", md: "6" }}>
      {children}
    </CardBody>
  </Card>
);
